module.exports = __webpack_public_path__ + "static/media/student-profiles.77cf0286.png";